/**
 * Created by jjing on 7/17/2017.
 */

import request from "superagent";
import writeLog from "./LogUtil.js";

export function signOut() {
  writeLog("logout", "logout", "Logout.");
  request
    .post("/api/logout")
    .withCredentials()
    .end((error, response) => {
      console.log("logout: " + response.body);
      sessionStorage.clear();
      window.location.href = response.body;
    });
}

// json schema validation
export const REG_EXP_LIST = {
  mac: "^[a-fA-F0-9]{12}$|^([0-9a-fA-F]{2}[:-]){5}([0-9a-fA-F]{2})$",
  onlyDigits: "^\\d+$",
  alphaNumeric: "^[a-zA-z0-9]+$"
};

export default function getUrl(service, includeTenantId, includeUaid, subUrl) {
  try {
    const ser = JSON.parse(sessionStorage.getItem("services"));
    if (!ser) {
      throw new Error("Services in storage is empty");
    }
    let url = ser[service.key][service.ver];
    if (subUrl) {
      url += subUrl;
    }

    let params = "";
    if (includeTenantId) {
      params += "tid=" + sessionStorage.getItem("tenantId");
    }
    if (includeUaid) {
      if (params !== "") {
        params += "&";
      }
      params += "uaid=" + sessionStorage.getItem("uaid");
    }

    if (params.length > 0) {
      url += (url.indexOf("?") === -1 ? "?" : "&") + params;
    }
    return url;
  } catch (err) {
    console.error("Failed to find service url", err);
    return "";
  }
}

export function transLng(lng) {
  const lngs = {
    en: "American English: en-US",
    "en-us": "American English: en-US",
    "en-gb": "British English: en-GB",
    zh: "Simplified Chinese: zh-CN",
    "zh-cn": "Simplified Chinese: zh-CN",
    "zh-tw": "Traditional Chinese: zh-TW",
    fr: "French: fr",
    de: "German: de",
    ja: "Japanese: ja",
    ko: "Korean: ko",
    es: "Spanish: es",
    ru: "Russian: ru",
    pt: "Portuguese: pt",
    ar: "Arabic: ar",
    hu: "Hungarian: hu",
    it: "Italian: it",
    pl: "Polish: pl",
    no: "Norwegian: no"
  };

  if (lngs[lng] !== undefined) {
    return lngs[lng];
  } else {
    lng = lng.substring(0, lng.indexOf("-"));
    if (lngs[lng] !== undefined) {
      return lngs[lng];
    } else {
      return "American English: en-US";
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/functions/CommonUtils.js